import { render, staticRenderFns } from "./RodapeDialog.vue?vue&type=template&id=20ad55aa&scoped=true"
import script from "./RodapeDialog.vue?vue&type=script&lang=js"
export * from "./RodapeDialog.vue?vue&type=script&lang=js"
import style0 from "./RodapeDialog.vue?vue&type=style&index=0&id=20ad55aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ad55aa",
  null
  
)

export default component.exports